webpackJsonp([213104986406069],{

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sidebar = __webpack_require__(21);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _reactstrap = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      _sidebar2.default,
	      null,
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          'h3',
	          { className: 'mb-4' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'faqs' })
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: props.data.html.html } })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _faqsLayout = __webpack_require__(155);
	
	var _faqsLayout2 = _interopRequireDefault(_faqsLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Sk\xE1kgreind | Algengar spurningar'
	      )
	    ),
	    _react2.default.createElement(_faqsLayout2.default, props)
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-faqs-index-is-js-2bd5829bd6f8ef399fa6.js